export default function IconLightbulb({ className }: { className?: string }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" id="Lightbulb--Streamline-Flex" height="14" width="14" className={className}>
			<g id="lightbulb--lighting-light-incandescent-bulb-lights">
				<path
					id="Vector"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M11.6241 5.0919c0.0054 -0.7697 -0.1954 -1.5268 -0.5815 -2.19269 -0.3861 -0.66589 -0.9434 -1.2163 -1.61402 -1.59409C8.75794 0.927334 7.99841 0.735938 7.22884 0.750805c-0.76958 0.014866 -1.52115 0.235454 -2.17669 0.638865 -0.65554 0.40341 -1.19115 0.97493 -1.55122 1.65523 -0.36008 0.68031 -0.5315 1.4446 -0.49646 2.21352 0.03504 0.76892 0.27526 1.51445 0.69571 2.15919 0.75082 1.15132 1.19534 1.57454 1.19534 2.94469 0 0.127 0.05048 0.2489 0.14033 0.3388 0.08986 0.0898 0.21173 0.1403 0.3388 0.1403H9.2494c0.12707 0 0.24894 -0.0505 0.33879 -0.1403 0.08985 -0.0899 0.14033 -0.2118 0.14033 -0.3388 0 -1.40317 0.49728 -1.8197 1.24308 -3.01308 0.4232 -0.67711 0.6492 -1.45884 0.6525 -2.25732Z"
					strokeWidth="1"
				></path>
				<path id="Vector_2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m5.99707 13.25 2.62973 0" strokeWidth="1"></path>
			</g>
		</svg>
	);
}
